<template>
  <div class="scroll-wrap" @mouseenter="pause" @mouseleave="play">
    <div ref="wrap" class="scroll-list-wrap">
      <div ref="list" class="scroll-list">
        <div class="scroll-item" v-for="(img, i) in imgList" :key="i">
          <Img
            :src="img.path"
            :alt="img.alt"
            :oss-params="{ format: 'webp' }"
            class="scroll-item-img"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getFeUrl } from '@/utils/url';
import Img from '@rendora/design/components/img/Img.vue';
import { gsap } from 'gsap';
import { onMounted, ref } from 'vue';

const wrap = ref<HTMLElement | null>(null);
const list = ref<HTMLElement | null>(null);

let tween: gsap.core.Tween;

const imgList = [
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-1.png'),
    alt: '欢度新春演播厅A',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-2.png'),
    alt: '金桂明月银屏悬灯',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-3.png'),
    alt: '雪夜极光三角木屋',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-4.png'),
    alt: '科幻自然春花漫草',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-5.png'),
    alt: '马卡龙解构艺术展厅',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-6.png'),
    alt: '纸飞机黑板报',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-7.png'),
    alt: '温室雨林三屏舞台',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-8.png'),
    alt: '虚拟城市天台',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-9.png'),
    alt: '落日暮光蓝调客厅',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-10.png'),
    alt: '白色简约高科技反诈中心',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-11.png'),
    alt: '现代都市新闻演播室B',
  },
  {
    path: getFeUrl('/youyan-platform/scene/banner/scene-12.png'),
    alt: '现代疗愈智能教室',
  },
];

onMounted(() => {
  const clone = list.value!.cloneNode(true);
  wrap.value!.appendChild(clone);

  const totalWidth = list.value!.offsetWidth;

  // 初始位置放左边
  gsap.set(wrap.value, { x: -totalWidth });

  // 无限向右移动
  tween = gsap.to(wrap.value, {
    x: 0,
    repeat: -1,
    duration: 80,
    ease: 'none',
  });
});

// 悬停暂停
const pause = () => tween?.pause();

// 离开继续
const play = () => tween?.resume();
</script>

<style scoped>
.scroll-wrap {
  margin-top: 100px;
  margin-bottom: 160px;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
}
.scroll-list-wrap {
  display: flex;
  width: 100%;
  aspect-ratio: 1920 / 280;
}

.scroll-list {
  display: flex;
  /* width: 100%; */
  /* aspect-ratio: 1920 / 280; */
}

.scroll-item {
  flex-shrink: 0;
  margin-right: 32px;
}

.scroll-item .scroll-item-img {
  height: 100%;
  aspect-ratio: 484 / 280;
  object-fit: cover;
  border-radius: var(--x-radius-large);
}
</style>
